
import { defineComponent } from 'vue';
import ButtonIconRound from '@/components/ButtonIconRound.vue';

export default defineComponent({
  components: {
    ButtonIconRound,
  },
});
